/**
 * Check if object is empty {}
 *
 * @param object {}
 * @returns bool
 */
export function isEmptyObject(object: any) {
  try {
    return JSON.stringify(object) === '{}';
  } catch {
    return true;
  }
}

/**
 * Compares two strings using strict equality (===), with optional trim and case-insensitivity.
 * By default, ignores case and trims whitespace.
 *
 * @param a - First string
 * @param b - Second string
 * @param options - Optional flags to trim (default: true) and ignore case (default: true)
 * @returns true if strings are considered equal, false otherwise
 */
export function equalsString(
  a?: string,
  b?: string,
  options: { trim?: boolean; ignoreCase?: boolean } = { trim: true, ignoreCase: true }
): boolean {
  if (a == null || b == null) return false;

  if (options.trim) {
    a = a.trim();
    b = b.trim();
  }

  if (options.ignoreCase) {
    a = a.toLowerCase();
    b = b.toLowerCase();
  }

  return a === b;
}
